<template>
  <div class="text-filter">
    <RInputWithSigns v-if="type === 'number'" ref="input" :value="model" @sign-changed="signChanged" />

    <RInput
      v-else
      placeholder="search"
      :value="model"
      is-search
      :debounce="800"
      no-label
      no-hint
      no-feedback-icon
      @input="valueChangedForTypeText"
      @clear="clearValue"
    />
  </div>
</template>

<script>
// Libraries
import { debounce } from 'lodash'
// Components
import RInputWithSigns from '@/ui/RInputWithSigns'

export default {
  components: {
    RInputWithSigns
  },

  data: () => ({
    model: null
  }),

  computed: {
    type() {
      const filter = this.params.filterParams.colDef.filter // CustomFilter || agTextColumnFilter
      return filter === 'CustomFilter' ? 'number' : 'text'
    }
  },

  mounted() {
    if (this.type === 'number') {
      this.cleave = new Cleave(this.$el.querySelector('input'), {
        numeral: true,
        numeralDecimalMark: '',
        delimiter: '',
        numeralDecimalScale: 2,
        onValueChanged: debounce(this.valueChangedForTypeNumber, 800)
      })
    }
  },

  methods: {
    valueChangedForTypeText(value) {
      if (this.type === 'number') return
      this.valueChanged(value)
    },

    valueChangedForTypeNumber({ target: { rawValue } }) {
      if (['', null].includes(rawValue) && this.model === null) return

      const comparison = this.$refs.input.getSign()

      this.model = rawValue
      this.params.parentFilterInstance(function(instance) {
        instance.onFloatingFilterChanged(comparison, Number(rawValue), 'number')
      })
    },

    valueChanged(value) {
      this.model = value
      this.params.parentFilterInstance(function(instance) {
        instance.onFloatingFilterChanged('equals', value)
      })
    },

    signChanged() {
      this.valueChangedForTypeNumber({ target: { rawValue: this.model } })
    },

    clearValue() {
      if (this.type === 'text') return
      this.model = null
      this.cleave.setRawValue(null)
    },

    onParentModelChanged(parentModel) {
      this.model = parentModel?.filter
    }
  }
}
</script>
